/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { arr_inArray, get_localized_string2, htmlspecialchars, mj_cloned_object } from './util.js';

import { mj } from './page-mj.js';
import { jQuery } from '../other/jquery-hooked.js';
import { mjt } from './i18ntexts.js';

import { MDSearchOptions } from './search-options-data.js';
import { SimpleFunctionCallScheduler } from './scheduler-util.js';

import { SearchRequest } from './search-request.js';

import './widget.js';
import './meta-filter-widgets.js';

/*
 *
 */
export let MVSearchOptions = function($,mj) {

	let m_container_elem;		// = $('#sopts-content')
	let m_container_title;		// = $('#sopts-title')

	let m_defaultToStarFn;
	let m_triggerSearchFn;
	let m_onOptionChangedFn;
	let m_optionChangedScheduler;

	let m_dataDepSpreadMap = {};		// map of depOptCfgLIdx to an array of optCfgLIdx, which must update its value list after a change
	let m_optionItemsMap = {};

	function init( container_elem, container_title, defaultToStarFn, triggerSearchFn, onOptionChangedFn ) {
		m_container_elem = container_elem;
		m_container_title = container_title;
		m_defaultToStarFn = defaultToStarFn;
		m_triggerSearchFn = triggerSearchFn;
		m_onOptionChangedFn = onOptionChangedFn;

		m_optionChangedScheduler = new SimpleFunctionCallScheduler(
			function( on_call_done, args ) {
				// called when an option was changed or resetted, or when the search form was submitted...
				const trigger = typeof args.trigger === 'undefined'
					? true // <-- called through direct user interaction
					: !!(args.trigger);

				setActive( isSomeFilterActive() );
				if( trigger ) {
					if( m_onOptionChangedFn ) m_onOptionChangedFn();
				}
				const $searchOptsContentElem = $(m_container_elem);
				if( updateOptionsVisibilityFromDependencies($searchOptsContentElem) > 0 ) {
					$searchOptsContentElem.triggerHandler('mjssearchoptionsvisibility_changed');
				}
				if( trigger ) {
					m_triggerSearchFn();
				}
				return on_call_done();
			}
		);
	}


	function getActiveMarkerElement() {
		return $('> .active-marker',m_container_title);
	}
	function getOptionItemElements() {
		return $('> .block > .es-item',m_container_elem);
	}
	function getOptionActiveMarkerElements() {
		return $('> .block .es-active-marker',m_container_elem);
	}

	function getContentElementIfVisible() {
		return $(m_container_elem).filter(':visible');
	}

	function containsElement( element ) {
		const $searchOptsContentElem = MVSearchOptions.getContentElementIfVisible();
		if( $searchOptsContentElem.length && $.contains($searchOptsContentElem[0],element) ) return true;
	}



	function isActive() {
		return getActiveMarkerElement().is(':visible');
	}

	function setActive( active ) {
		getActiveMarkerElement().toggle(active);
	}

	function isSomeFilterActive() {
		return getOptionActiveMarkerElements().is(':visible');
	}


	function resetOptions() {
		getOptionItemElements().mjMetaFilterWidget('reset');
		getOptionActiveMarkerElements().hide();
		getActiveMarkerElement().hide();
		$(m_container_elem).triggerHandler('mjssearchoptionsvisibility_changed');
		m_defaultToStarFn();
	}



	function getSanitizedExtendedSearchOptionData( o ) {
		return {
			config:		mj_cloned_object(o.config),
			meta_id:	o.meta_id,
			meta_type:	o.meta_type,
			title:		o.title,
			type:		o.type
		};
	}

	function selectOptionForSearchByMeta( searchRequest, data, meta_id ) {
		let matched_an_option = false;
		getOptionItemElements().filter(':visible').each( function( sopts_idx ) {
			const mjMFWCfg = $(this).mjMetaFilterWidget('config');
			if( mjMFWCfg.meta_id==meta_id && !mjMFWCfg.init_in_progress ) {
				if( mjMFWCfg.type==='list' || mjMFWCfg.type==='val_list' || mjMFWCfg.type==='auto_list' || mjMFWCfg.type==='auto2_list' || mjMFWCfg.type==='auto3_set' ) {
					const vals = mjMFWCfg.config.values;
					for( let i=0; i<vals.length; ++i ) {
						const vk = vals[i][0][0];
						if( vk[0]==='e' && ( Array.isArray(data) ? arr_inArray(vk[i],data)!==-1 : vk[1]===data ) ) {
							//console.log(['matched auto_list value',vals[i]]);
							searchRequest.setOption( getSanitizedExtendedSearchOptionData(mjMFWCfg), JSON.stringify([vk]), vals[i][1] );
							matched_an_option = true;
							return false; // break each()
						}
					}
					return false; // break each()
				} else if( ( mjMFWCfg.type==='set' || mjMFWCfg.type==='val_set' || mjMFWCfg.type==='auto_set' || mjMFWCfg.type==='auto2_set' ) && mjMFWCfg.config.op==='eo' ) {
					const vals = mjMFWCfg.config.values;
					for( let i=0; i<vals.length; ++i ) {
						const vk = vals[i][0];
						if( Array.isArray(data) ? arr_inArray(vk,data)!==-1 : vk===data ) {
							//console.log(['matched auto_set value',vals[i]]);
							searchRequest.setOption( getSanitizedExtendedSearchOptionData(mjMFWCfg), [vk], vals[i][1] );
							matched_an_option = true;
							return false; // break each()
						}
					}
					return false; // break each()
				}
			}
		});
		return matched_an_option;
	}



	function updateSearchRequestState( searchRequestState ) {
		searchRequestState.options = [];
		getOptionItemElements().each( function( sopts_idx ) {
			const self = $(this);
			if( !self.mjMetaFilterWidget('empty') ) {
				const value = self.mjMetaFilterWidget('get');
				const config = getSanitizedExtendedSearchOptionData(self.mjMetaFilterWidget('config'));
				const o = {
					config,
					value,
					display_value: self.mjMetaFilterWidget('format',value),
				};
				searchRequestState.options.push(o);
			}
		} );
	}




	function updateOptionsVisibilityFromDependencies( $searchOptsContentElem ) {
		let changed_count = 0;
		const $sopts_blocks = $searchOptsContentElem.find('> .block');
		$sopts_blocks.each( function() {
			const blk = $(this);
			const optConfig = blk.data('mj-search-opt-cfg');
			let shouldBeVisible = true;
			if( optConfig.hasOwnProperty('dependencies') && optConfig.dependencies.length>0 ) {
				shouldBeVisible = false;
				const depsLen = optConfig.dependencies.length;
				for( let i=0; i<depsLen; ++i ) {
					const dep_meta_id = optConfig.dependencies[i];
					// const dep_item = $sopts_blocks.filter('.sopts-item-'+dep_meta_id).children('.es-item');
					const dep_item = m_optionItemsMap[dep_meta_id].$esItem;
					const mfwOpts = dep_item.data('mj-mfw-opts');
					if( mfwOpts ) {
						const dep_empty = dep_item.mjMetaFilterWidget('empty');
						if( !dep_empty ) {
							shouldBeVisible = true;
							break;
						}
					}
				}
				if( !shouldBeVisible ) {
					const $esItem = blk.children('.es-item');
					const mfwOpts = $esItem.data('mj-mfw-opts');
					if( mfwOpts ) {
						$esItem.mjMetaFilterWidget('reset');
					}
				}
			// } else if( optConfig.hasOwnProperty('data_dependencies') && optConfig.data_dependencies.length ) {
			}
			const currentlyVisible = !blk.hasClass('hidden-by-dependencies');
			if( shouldBeVisible != currentlyVisible) {
				blk.toggleClass('hidden-by-dependencies',!shouldBeVisible);
				changed_count ++;
			}
		} );
		return changed_count;
	}




	function setupOptionsView( optionsConfigurationList ) {
		var $searchOptsContentElem = $(m_container_elem).empty();

		// called when value of an option changed
		const onOptionItemChange = function( trigger ) {
			const $self = $(this);
			const mfwIsEmpty = $self.mjMetaFilterWidget('empty');
			$self.closest('.block').toggleClass('active',!mfwIsEmpty).find('.es-active-marker').toggle( !mfwIsEmpty );

			const mfwOpts = $self.data('mj-mfw-opts');
			if( m_dataDepSpreadMap.hasOwnProperty(mfwOpts.optCfgLIdx) ) {
				const filterOptionPostData = $self.mjMetaFilterWidget('getPostData');
				for( const spreadToOptCfgLIdx of m_dataDepSpreadMap[mfwOpts.optCfgLIdx] ) {
					const spreadToMetaId = optionsConfigurationList[spreadToOptCfgLIdx].meta_id;
					const $spreadToEsItem = m_optionItemsMap[spreadToMetaId].$esItem;
					if( $spreadToEsItem.data('mj-mfw-opts') ) {
						$spreadToEsItem.mjMetaFilterWidget('updateDependentFilterOption',mfwOpts.optCfgLIdx,filterOptionPostData,mfwOpts);
					}
				}
			}
			if( trigger ) {
				// cancel old request and schedule new one as soon as possible (for low latency UI feedback)
				m_optionChangedScheduler.cancel();
				m_optionChangedScheduler.schedule( 4, { trigger } );
			} else {
				m_optionChangedScheduler.schedule( 32, { trigger } );
			}
		};


		const option_init_done = function( opts ) {
			$searchOptsContentElem.triggerHandler('mjssearchoptionsvisibility_changed');
		};


		const ol = optionsConfigurationList.length;

		// 1. create data dependency spread map
		// - which defines the initialization order of the options elements widgets
		m_dataDepSpreadMap = {};
		for( let optCfgLIdx=0; optCfgLIdx<ol; ++optCfgLIdx ) {
			const optConfig = optionsConfigurationList[optCfgLIdx];
			optConfig.optCfgLIdx = optCfgLIdx;
			// const optMetaId = optConfig.meta_id;
			optConfig.change = onOptionItemChange;
			optConfig.init_done = option_init_done;

			if( optConfig.hasOwnProperty('data_dependencies') && optConfig.data_dependencies.length ) {
				optConfig.data_dependencies_idxs = [];
				for( let ddepIdx=0; ddepIdx<optConfig.data_dependencies.length; ++ddepIdx ) {
					const depMetaId = optConfig.data_dependencies[ddepIdx];
					for( let depOptCfgLIdx=0; depOptCfgLIdx<ol; ++depOptCfgLIdx ) {
						const depOptConfig = optionsConfigurationList[depOptCfgLIdx];
						if( depOptConfig.meta_id==depMetaId ) {

							/////HACK///////
							// --> data_dependencies contains the meta_id of other filters,
							// --> but here, we need the __indexes__ instead (because we can have multiple filters, even from same meta_id)
							// --> TODO: real solution
							// until then:
							optConfig.data_dependencies_idxs[ddepIdx] = depOptCfgLIdx;
							/////HACK///////

							if( m_dataDepSpreadMap.hasOwnProperty(depOptCfgLIdx) ) m_dataDepSpreadMap[depOptCfgLIdx].push(optCfgLIdx);
							else m_dataDepSpreadMap[depOptCfgLIdx] = [optCfgLIdx];
						}
					}
				}
			}
		}

		// 2. create options elements
		m_optionItemsMap = {};
		for( let optCfgLIdx=0; optCfgLIdx<ol; ++optCfgLIdx ) {
			const optConfig = optionsConfigurationList[optCfgLIdx];
			const $block = $('<div class="block sopts-item-'+optConfig.meta_id+' filter-options-items">'
							+ '<span class="block-title-row">'
								+ '<span class="block-title">'+htmlspecialchars(get_localized_string2(optConfig.title,mj.locale))+'</span>'
								+ '<span class="es-active-marker link" style="display:none" title="'+mjt('search-options-filter-active-hover')+'">'+mjt('search-options-filter-active')+'</span>'
							+ '</span>'
							+ '<div class="row es-item"></div>'
							+ '</div>')
				.data('mj-search-opt-cfg',optConfig)
				.appendTo($searchOptsContentElem);
			const $esItem = $block.children('.es-item');
			const optLayoutOptions = optConfig.layout_options ?? {};

			if( optLayoutOptions.space_above ) {
				$block.addClass('block-space-above');
				$esItem.addClass('es-item-space-above');
			}
			if( optLayoutOptions.separator_above ) {
				$block.addClass('block-separator-above');
			}

			if( (optLayoutOptions.hint??'')!=='' ) {
				const localHintText = get_localized_string2(optLayoutOptions.hint??'',mj.locale);
				if(localHintText !== '') {
					const hint = $('<span class="sidebar-tooltip-icon" title="'+mjt('more-info')+'"></span>').mjWidget({
						type: 'tooltip',
						text: localHintText,
						title: htmlspecialchars(get_localized_string2(optConfig.title,mj.locale))
					});
					$block.find('.block-title').append(hint);
				}
			}

			if( optLayoutOptions.space_below ) {
				$block.addClass('block-space-below');
				$esItem.addClass('es-item-space-below');
			}
			if( optLayoutOptions.separator_below ) {
				$block.addClass('block-separator-below');
			}


			m_optionItemsMap[optConfig.meta_id] = {
				optConfig,
				$esItem,
			};
			if( optConfig.hasOwnProperty('data_dependencies_idxs') && optConfig.data_dependencies_idxs.length ) {
				// defer init until data deps loaded...
				// ... mjMetaFilterWidget can do that on its own
				optConfig.waitForDataDependenciesArr = optConfig.data_dependencies_idxs;
			}

			optConfig.load_filtered_data_start = function( opts, isInitialUpdate, filterOpts, dcKey, dcState ) {
				// console.log({ w:'load_filtered_data_start', metaId:opts.meta_id, iiu:isInitialUpdate,  dcKey, curDCKey:opts.curDCKey,  title:get_localized_string2(opts.title,mj.locale),  filterOpts, dcState });
				const $block = $(this).closest('.block');
				$block.addClass('loading-filtered-data');
				$('select,input[type=checkbox]',this).prop('disabled',true);
			};
			optConfig.load_filtered_data_done  = function( opts, isInitialUpdate, filterOpts, dcKey, dcState, dataValueList ) {
				// console.log({ w:'load_filtered_data_DONE ', metaId:opts.meta_id, iiu:isInitialUpdate,  dcKey, curDCKey:opts.curDCKey,  title:get_localized_string2(opts.title,mj.locale),  filterOpts, dcState,   dataValueList });
				$('select,input[type=checkbox]',this).prop('disabled',false);
				const $block = $(this).closest('.block');
				$block.removeClass('loading-filtered-data');
				if( optLayoutOptions.hide_when_data_deps_value_list_empty??false ) {
					$block.toggleClass('hidden-by-data-dependencies-empty-list',dataValueList.length===0);
				}
			};

			$esItem.mjMetaFilterWidget(optConfig);
		}

		getOptionActiveMarkerElements().off('.MVSearchOptions').on('click.MVSearchOptions', function() {
			const $self = $(this);
			$self.closest('.block').removeClass('active').children('.es-item').mjMetaFilterWidget('reset',true);
			$self.hide();
		} );

		$searchOptsContentElem.find('input,textarea,select').off('.MVSearchOptions').on('keydown.MVSearchOptions', function(e) {
			// on enter: trigger form submit, but do not reset extended options
			if( e.keyCode==13 ) {
				e.preventDefault();
				e.stopPropagation();
				// defer - to avoid an immediate keydown in search result
				m_optionChangedScheduler.schedule( 4, {} );
				return false;
			}
		} );

		getActiveMarkerElement().off('.MVSearchOptions').on('click.MVSearchOptions', function() {
			resetOptions();
			m_triggerSearchFn();
			return false;
		} );

		$searchOptsContentElem.off('.MVSearchOptions').on('mjscontainerclose.MVSearchOptions', function() {
			if( isActive() ) {
				resetOptions();
				m_triggerSearchFn();
			}
		} );

		if( updateOptionsVisibilityFromDependencies($searchOptsContentElem) > 0 ) {
			$searchOptsContentElem.triggerHandler('mjssearchoptionsvisibility_changed');
		}
	}






	function participateInTriggerSearchByRequestObject( searchRequestState, externalState ) {
		let optionsByKeyMap = MDSearchOptions.createOptionsByKeyMap(searchRequestState);

		function _defered_setMetaFilterWidgetValue( mfwidget, key, value, done_cb, is_defered ) {
			if( mfwidget.mjMetaFilterWidget('is_init_in_progress') ) {
				setTimeout( function() {
					_defered_setMetaFilterWidgetValue(mfwidget,key,value,done_cb,true);
				}, 36 );
			} else {
				mfwidget.mjMetaFilterWidget('set',value);
				if( done_cb ) done_cb(is_defered);
			}
		}

		let options_filter_active = false;

		getOptionItemElements().each( function() {
			const self = $(this);
			const mjMFWCfg = self.mjMetaFilterWidget('config');
			const typedOptionKey = SearchRequest.createOptionKey(mjMFWCfg);

			if( !optionsByKeyMap.hasOwnProperty(typedOptionKey) ) {
				const convertedOptionsValue = MDSearchOptions.tryConvertOptionsValue(mjMFWCfg,optionsByKeyMap);
				if( convertedOptionsValue!==null ) {
					optionsByKeyMap[typedOptionKey] = convertedOptionsValue;
				}
			}

			if( optionsByKeyMap.hasOwnProperty(typedOptionKey) ) {
				externalState.preconditions ++;
				_defered_setMetaFilterWidgetValue( self, typedOptionKey, optionsByKeyMap[typedOptionKey].value||null, function( is_defered ) {
					// trigger the defered change (to update dependencies, active markers, etc)
					if( is_defered && mjMFWCfg.change ) mjMFWCfg.change.call(self,false);
					externalState.preconditions --;
					if( is_defered && externalState.preconditions===0 ) {
						externalState.tryExec(false,false);
					}
				}, false );
				options_filter_active = true;
			} else if( !self.mjMetaFilterWidget('empty') ) {
				self.mjMetaFilterWidget('reset');
			}
			// trigger the change (to update dependencies, active markers, etc)
			if( mjMFWCfg.change ) {
				mjMFWCfg.change.call(self,false);
			}
		} );

		return options_filter_active;
	}


	function getFocusableNodes() {
		let $res_nodes = $([]);

		const $searchOptsContentElem = getContentElementIfVisible();
		if( $searchOptsContentElem.length ) {
			const $sopts_nodes = $searchOptsContentElem
				.find('input,textarea,select:not(.select2-hidden-accessible)')
				.not('[disabled],input[type=image],input[type=hidden]')
				.filter(':visible');
			$res_nodes = $res_nodes.add($sopts_nodes);

			/** LATER?
			var eam_nodes = $searchOptsContentElem
								.find('> .block .es-active-marker')	//.find('span.es-active-marker.link')
								.filter(':visible')
								.attr('tabindex',0); // .. make focusable & tabbable
			res_nodes = res_nodes.add( eam_nodes );
			**/

			/*
			// NOTE: "input.select2-search__field" element gets focus instead of "span.select2-selection--multiple" - so thats already included by 'input' selector above
			var compat_s2_nodes = $searchOptsContentElem.find('span.select2-selection:not(.select2-selection--multiple)')
										.not('[disabled],input[type=image],input[type=hidden]')
										.filter(':visible').filter(':focusable').filter(':tabbable');
			res_nodes = res_nodes.add( compat_s2_nodes );
			*/

			let select2NodesArr = [];
			$searchOptsContentElem.find('span.select2-selection').filter(':visible').each( function() {
				const $select2Elem = $(this);
				const $select2ContainerElem = $select2Elem.closest('.select2.select2-container');
				const $plainSelectElem = $select2ContainerElem.prev('select.select2-hidden-accessible');
				const select2Obj = $plainSelectElem.data('select2');

				let $select2FocusNode  = null;
				const $search__field = select2Obj.dropdown.$search || select2Obj.selection.$search || select2Obj.$container.find('.select2-search__field');
				if( $search__field.length && $search__field.attr('tabindex')!=-1 && ( select2Obj.dropdown.$searchContainer && !select2Obj.dropdown.$searchContainer.hasClass('select2-search--hide') ) ) {
					if( $.contains(document.documentElement,$search__field[0]) ) {
						$select2FocusNode = $search__field[0];
					}
				}

				const isMultiSelect = $select2Elem.hasClass('select2-selection--multiple');
				if( isMultiSelect ) {
					// TODO
				} else {
					select2NodesArr.push($select2Elem[0]);
					if( $select2FocusNode ) select2NodesArr.push($select2FocusNode);
				}
			});

			$res_nodes = $res_nodes.add(select2NodesArr);
		}
		return $res_nodes;
	}





	return {
		init,

		getActiveMarkerElement,
		getOptionItemElements,
		getOptionActiveMarkerElements,

		getContentElementIfVisible,
		containsElement,


		isActive,
		setActive,
		isSomeFilterActive,

		resetOptions,

		selectOptionForSearchByMeta,
		updateSearchRequestState,

		setupOptionsView,

		participateInTriggerSearchByRequestObject,

		getFocusableNodes,

	};
}(jQuery,mj); // namespace MVSearchOptions

